import React from 'react';
import cc from 'classnames';

import styles from './FieldsInputsLeveler.module.css';

interface IFieldsLevelerProps {
  dividerBottom?: boolean,
  children: React.ReactNode,
}

const FieldsInputsLever = ({ dividerBottom, children }: IFieldsLevelerProps) => (
  <div className={cc(styles.grid, { [styles.dividerBottom]: dividerBottom })}>
    <div className={styles.field}>{children}</div>
  </div>
);

export default FieldsInputsLever;
